exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn[data-v-c9445fda] {\n  border-radius: 15px 15px 0 0;\n}\n@media only screen and (max-width: 600px) {\n.btn > h4[data-v-c9445fda] {\n    font-size: 1.2rem;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c9445fda","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/portal/userAccount/UserAccount.vue
// module id = 332
// module chunks = 3